<template>
  <div class="container-list">
    <div class="common-page common-head">
      <div class="common-page common-head-title">
        <i class="icon-tr--detailed" style="padding-right: 5px"></i>
        消防设施设置
        <!-- <breadcrumb id="breadcrumb-container" class="breadcrumb-container icon-tr--detailed" /> -->
      </div>

      <!--            <div class="common-page common-head-end" @click="$router.back()">-->
      <!--                <i class="icon-tr-sign-out"></i>-->
      <!--            </div>-->
    </div>
    <div class="flex">
      <!-- <unitList 
        
      
       @select="getUnit" @getFirst="getOne" ></unitList> -->
      <div class="flex1">
        <div class="common-page common-tool-bar">
          <el-row :gutter="10" class="mb8">
            <el-col :span="1.5">
              <el-button type="primary" icon="el-icon-plus" @click="handleAdd" v-hasPermi="['trmoni:fireFacilities:add']">新增</el-button>
            </el-col>
            <!-- <el-col :span="1.5">
        <el-button
          type="success"
          icon="el-icon-edit"
          size="mini"
          :disabled="single"
          @click="handleUpdate"
          v-hasPermi="['trmoni:fireFacilities:edit']"
        >修改</el-button>
      </el-col> -->
            <!--      <el-col :span="1.5">-->
            <!--        <el-button-->
            <!--          type="danger"-->
            <!--          icon="el-icon-delete"-->
            <!--          size="mini"-->
            <!--          :disabled="multiple"-->
            <!--          @click="handleDelete"-->
            <!--          v-hasPermi="['trmoni:fireFacilities:remove']"-->
            <!--        >删除</el-button>-->
            <!--      </el-col>-->
            <!-- <el-col :span="1.5">
        <el-button
          type="warning"
          icon="el-icon-download"
          size="mini"
          @click="handleExport"
          v-hasPermi="['trmoni:fireFacilities:export']"
        >导出</el-button>
      </el-col> -->
            <right-toolbar :showSearch.sync="showSearch" @queryTable="getList"></right-toolbar>
          </el-row>
        </div>

        <el-table v-loading="loading" :data="fireFacilitiesList" @selection-change="handleSelectionChange">
          <!-- <el-table-column type="selection" width="55" align="center" /> -->
          <el-table-column label="主键" align="center" prop="id" v-if="false" />
          <el-table-column label="设施名称" align="center" prop="name" />
          <el-table-column label="使用年限" align="center" prop="usePeriod" />
          <el-table-column label="第1次维修年限" align="center" prop="firstMaintenanceTime" />
          <el-table-column label="第2次维修年限" align="center" prop="secondMaintenanceTime" />
          <el-table-column label="第3次维修年限" align="center" prop="thirdMaintenanceTime" />
          <el-table-column label="第4次维修年限" align="center" prop="fourthMaintenanceTime" />
          <el-table-column label="快到期提醒时间（月）" align="center" prop="reminderTime" />
          <!-- <el-table-column label="状态: 1:开启 0:关闭" align="center" prop="status" /> -->
          <!-- <el-table-column label="备注" align="center" prop="remark" /> -->
          <el-table-column label="操作" align="center" class-name="small-padding ">
            <template slot-scope="scope">
              <el-button size="mini" type="warning" @click="handleUpdate(scope.row)" v-hasPermi="['trmoni:fireFacilities:edit']">修改</el-button>
              <el-button size="mini" type="danger" @click="handleDelete(scope.row)" v-hasPermi="['trmoni:fireFacilities:remove']">删除</el-button>
            </template>
          </el-table-column>
        </el-table>

        <pagination v-show="total > 0" :total="total" :page.sync="queryParams.pageNum" :limit.sync="queryParams.pageSize" @pagination="getList" />
      </div>
    </div>

    <!-- 添加或修改消防设施设置对话框 -->
    <el-dialog :title="title" :visible.sync="open" width="800px" append-to-body>
      <el-form ref="form" :model="form" :rules="rules" label-width="120px">
        <el-form-item label="设施名称" prop="name">
          <el-input v-model="form.name" placeholder="请输入设施名称" />
        </el-form-item>
        <el-form-item label="使用年限" prop="usePeriod">
          <el-input v-model="form.usePeriod" placeholder="请输入使用年限" />
        </el-form-item>
        <el-form-item label="第1次维修年限" prop="firstMaintenanceTime">
          <el-input v-model="form.firstMaintenanceTime" placeholder="请输入第1次维修年限" />
        </el-form-item>
        <el-form-item label="第2次维修年限" prop="secondMaintenanceTime">
          <el-input v-model="form.secondMaintenanceTime" placeholder="请输入第2次维修年限" />
        </el-form-item>
        <el-form-item label="第3次维修年限" prop="thirdMaintenanceTime">
          <el-input v-model="form.thirdMaintenanceTime" placeholder="请输入第3次维修年限" />
        </el-form-item>
        <el-form-item label="第4次维修年限" prop="fourthMaintenanceTime">
          <el-input v-model="form.fourthMaintenanceTime" placeholder="请输入第4次维修年限" />
        </el-form-item>
        <el-form-item label="快到期提醒时间" prop="reminderTime">
          <el-input v-model="form.reminderTime" placeholder="请输入快到期提醒时间" />
        </el-form-item>
        <!--        <el-form-item label="状态: 1:开启 0:关闭">-->
        <!--          <el-radio-group v-model="form.status">-->
        <!--            <el-radio label="1">请选择字典生成</el-radio>-->
        <!--          </el-radio-group>-->
        <!--        </el-form-item>-->
        <!--        <el-form-item label="备注" prop="remark">-->
        <!--          <el-input v-model="form.remark" placeholder="请输入备注" />-->
        <!--        </el-form-item>-->
        <!--        <el-form-item label="删除标记 1:存在 0:删除" prop="delFlag">-->
        <!--          <el-input v-model="form.delFlag" placeholder="请输入删除标记 1:存在 0:删除" />-->
        <!--        </el-form-item>-->
      </el-form>
      <div slot="footer" class="dialog-footer center">
        <el-button type="primary" @click="submitForm">确 定</el-button>
        <el-button @click="cancel">取 消</el-button>
      </div>
    </el-dialog>

    <el-dialog title="查询" :visible.sync="showSearch" :close-on-click-modal="false">
      <el-form :model="queryParams" ref="queryForm" :inline="true" label-width="68px">
        <el-form-item label="设施名称" prop="name">
          <el-input v-model="queryParams.name" placeholder="请输入设施名称" clearable size="small" @keyup.enter.native="handleQuery" />
        </el-form-item>
        <!--      <el-form-item label="使用年限" prop="usePeriod">-->
        <!--        <el-input-->
        <!--          v-model="queryParams.usePeriod"-->
        <!--          placeholder="请输入使用年限"-->
        <!--          clearable-->
        <!--          size="small"-->
        <!--          @keyup.enter.native="handleQuery"-->
        <!--        />-->
        <!--      </el-form-item>-->
        <!--      <el-form-item label="第1次维修年限" prop="firstMaintenanceTime">-->
        <!--        <el-input-->
        <!--          v-model="queryParams.firstMaintenanceTime"-->
        <!--          placeholder="请输入第1次维修年限"-->
        <!--          clearable-->
        <!--          size="small"-->
        <!--          @keyup.enter.native="handleQuery"-->
        <!--        />-->
        <!--      </el-form-item>-->
        <!--      <el-form-item label="第2次维修年限" prop="secondMaintenanceTime">-->
        <!--        <el-input-->
        <!--          v-model="queryParams.secondMaintenanceTime"-->
        <!--          placeholder="请输入第2次维修年限"-->
        <!--          clearable-->
        <!--          size="small"-->
        <!--          @keyup.enter.native="handleQuery"-->
        <!--        />-->
        <!--      </el-form-item>-->
        <!--      <el-form-item label="第3次维修年限" prop="thirdMaintenanceTime">-->
        <!--        <el-input-->
        <!--          v-model="queryParams.thirdMaintenanceTime"-->
        <!--          placeholder="请输入第3次维修年限"-->
        <!--          clearable-->
        <!--          size="small"-->
        <!--          @keyup.enter.native="handleQuery"-->
        <!--        />-->
        <!--      </el-form-item>-->
        <!--      <el-form-item label="第4次维修年限" prop="fourthMaintenanceTime">-->
        <!--        <el-input-->
        <!--          v-model="queryParams.fourthMaintenanceTime"-->
        <!--          placeholder="请输入第4次维修年限"-->
        <!--          clearable-->
        <!--          size="small"-->
        <!--          @keyup.enter.native="handleQuery"-->
        <!--        />-->
        <!--      </el-form-item>-->
        <!--      <el-form-item label="快到期提醒时间" prop="reminderTime">-->
        <!--        <el-input-->
        <!--          v-model="queryParams.reminderTime"-->
        <!--          placeholder="请输入快到期提醒时间"-->
        <!--          clearable-->
        <!--          size="small"-->
        <!--          @keyup.enter.native="handleQuery"-->
        <!--        />-->
        <!--      </el-form-item>-->
        <!--      <el-form-item label="状态: 1:开启 0:关闭" prop="status">-->
        <!--        <el-select v-model="queryParams.status" placeholder="请选择状态: 1:开启 0:关闭" clearable size="small">-->
        <!--          <el-option label="请选择字典生成" value="" />-->
        <!--        </el-select>-->
        <!--      </el-form-item>-->
        <div class="center">
          <el-button type="cyan" icon="el-icon-search" size="mini" @click="handleQuery">搜索</el-button>
          <el-button icon="el-icon-refresh" size="mini" @click="resetQuery">重置</el-button>
        </div>
      </el-form>
    </el-dialog>
  </div>
</template>

<script>
import {
  listFireFacilities,
  getFireFacilities,
  delFireFacilities,
  addFireFacilities,
  updateFireFacilities,
  exportFireFacilities,
} from "@/api/trmonitor/fireFacilities";
// import unitList from "@/components/unitList";

export default {
  name: "FireFacilities",
  // components:{unitList},
  data() {
    return {
      // 遮罩层
      loading: true,
      // 选中数组
      ids: [],
      // 非单个禁用
      single: true,
      // 非多个禁用
      multiple: true,
      // 显示搜索条件
      showSearch: false,
      cpNum: "",
      // 总条数
      total: 0,
      // 消防设施设置表格数据
      fireFacilitiesList: [],
      // 弹出层标题
      title: "",
      // 是否显示弹出层
      open: false,
      // 查询参数
      queryParams: {
        pageNum: 1,
        pageSize: 10,
        name: null,
        usePeriod: null,
        firstMaintenanceTime: null,
        secondMaintenanceTime: null,
        thirdMaintenanceTime: null,
        fourthMaintenanceTime: null,
        // cCompanyNum:'',
        reminderTime: null,
        status: null,
      },
      // 表单参数
      form: {},
      // 表单校验
      rules: {},
    };
  },
  created() {
    this.getList();
  },
  watch: {
    //  cpNum(){
    //     this.params.c_company_num  = this.cpNum
    //     this.params.page = 1
    //     this.getList()
    // },
  },
  methods: {
    /** 查询消防设施设置列表 */
    //      getOne(v){
    //      this.cpNum = v
    //  },
    //  getUnit(v){
    //      this.cpNum = v
    //  },
    getList() {
      this.loading = true;
      listFireFacilities(this.queryParams).then((response) => {
        this.fireFacilitiesList = response.rows;
        this.total = response.total;
        this.loading = false;
      });
    },
    // 取消按钮
    cancel() {
      this.open = false;
      this.reset();
    },
    // 表单重置
    reset() {
      this.form = {
        id: null,
        name: null,
        usePeriod: null,
        firstMaintenanceTime: null,
        secondMaintenanceTime: null,
        thirdMaintenanceTime: null,
        fourthMaintenanceTime: null,
        reminderTime: null,
        status: 1,
        remark: null,
        createTime: null,
        updateTime: null,
        delFlag: null,
      };
      this.resetForm("form");
    },
    /** 搜索按钮操作 */
    handleQuery() {
      this.queryParams.pageNum = 1;
      this.getList();
    },
    /** 重置按钮操作 */
    resetQuery() {
      this.resetForm("queryForm");
      this.handleQuery();
    },
    // 多选框选中数据
    handleSelectionChange(selection) {
      this.ids = selection.map((item) => item.id);
      this.single = selection.length !== 1;
      this.multiple = !selection.length;
    },
    /** 新增按钮操作 */
    handleAdd() {
      this.reset();
      this.open = true;
      this.title = "添加消防设施设置";
    },
    /** 修改按钮操作 */
    handleUpdate(row) {
      this.reset();
      const id = row.id || this.ids;
      getFireFacilities(id).then((response) => {
        this.form = response.data;
        this.open = true;
        this.title = "修改消防设施设置";
      });
    },
    /** 提交按钮 */
    submitForm() {
      this.$refs["form"].validate((valid) => {
        if (valid) {
          if (this.form.id != null) {
            updateFireFacilities(this.form).then((response) => {
              // this.$message.success("修改成功");
              this.$message({ 
										message: "修改成功", 
										type: "success", 
										duration: 700,});
              this.open = false;
              this.getList();
            });
          } else {
            addFireFacilities(this.form).then((response) => {
              this.$message({ 
										message: "新增成功", 
										type: "success", 
										duration: 700,});
              // this.$message.success("新增成功");
              this.open = false;
              this.getList();
            });
          }
        }
      });
    },
    /** 删除按钮操作 */
    handleDelete(row) {
      const id = row.id;
      this.$confirm('是否确认删除消防设施设置编号为"' + id + '"的数据项?', "警告", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning",
      })
        .then(function() {
          return delFireFacilities(id);
        })
        .then(() => {
          this.getList();
          // this.msgSuccess("删除成功");
          this.$message({
									message: '删除成功',
									type: 'success',
									duration: 700,
								});
        });
    },
    /** 导出按钮操作 */
    handleExport() {
      const queryParams = this.queryParams;
      this.$confirm("是否确认导出所有消防设施设置数据项?", "警告", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning",
      })
        .then(function() {
          return exportFireFacilities(queryParams);
        })
        .then((response) => {
          this.download(response.msg);
        });
    },
  },
};
</script>
